import { getAuthHeaders } from '../utils/authHeaders';
import { createFormPdf, yesNoColor, formatYesNo } from '../utils/formPdf';

const API_URL = 'https://app.pvslimited.co.uk/api';

const sendEngineeringEmail = async (formData) => {
  try {
    const blob = await createFormPdf({
      title: 'ENGINEERING FORM',
      ref: 'Ref: PVS-ENG-001 | Version: 1.0',
    }, (pdf) => {
      pdf.section('BASIC INFORMATION');
      pdf.field('Engineer Name', formData.engineerName);
      pdf.field('Job Location', formData.jobLocation);
      pdf.field('Company Representing', formData.companyRepresenting);
      pdf.field('Date Completed', formData.dateCompleted);
      pdf.field('Time on Site', formData.timeOnSite);

      pdf.section('JOB DETAILS');
      pdf.longText('Job Description', formData.jobDescription || 'No description provided');
      pdf.longText('Parts Used', formData.partsUsed || 'No parts listed');
      if (formData.startTime && formData.endTime) {
        pdf.field('Time Details', `${formData.startTime} - ${formData.endTime}`);
      }

      pdf.section('WORK STATUS');
      pdf.field('Work Complete', formatYesNo(formData.workComplete), yesNoColor(formData.workComplete));
      if (formData.reasonForIncomplete) {
        pdf.longText('Reason for work not being completed', formData.reasonForIncomplete);
      }

      if (formData.notes) {
        pdf.section('ADDITIONAL NOTES');
        pdf.longText('', formData.notes);
      }
    });

    const formDataToSend = new FormData();
    const safeName = String(formData.engineerName || 'engineer').replace(/[^a-zA-Z0-9-_]/g, '_');
    formDataToSend.append('file', blob, `Engineering_Form_${safeName}_${Date.now()}.pdf`);
    formDataToSend.append('engineerName', formData.engineerName);
    formDataToSend.append('jobLocation', formData.jobLocation);
    formDataToSend.append('companyRepresenting', formData.companyRepresenting);
    formDataToSend.append('dateCompleted', formData.dateCompleted);
    formDataToSend.append('workComplete', formData.workComplete);
    formDataToSend.append('reasonForIncomplete', formData.reasonForIncomplete || '');
    formDataToSend.append('formType', 'engineering-form');

    const response = await fetch(`${API_URL}/send-engineering-email`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: formDataToSend,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    return response.json();
  } catch (error) {
    console.error('Error in sendEngineeringEmail:', error);
    throw error;
  }
};

export default sendEngineeringEmail;
